import React, { useMemo } from 'react';

import { TableCDS } from 'app/shared/componentsRestyled/coreDesignSystem/Table';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import _ from 'lodash';
import PropTypes from 'prop-types';

import useSort from 'hooks/useSort';

import { UnderwritingTestIds } from '../../Underwriting.testIds';

import { validationRulesTableConfig } from './Incomes.config';
import { tableWrapperStyles } from './Incomes.styles';

const defaultOrder = {
  direction: 'asc',
  id: 'ruleName',
};

const defaultValidationRules = [];

const ValidationRulesTable = ({ isLoading, validationRules = defaultValidationRules }) => {
  const { order, onRequestSort } = useSort(defaultOrder);

  const orderedValidationRules = useMemo(
    () =>
      _.orderBy(
        validationRules,
        [item => item[order.id]?.toString()?.toLowerCase()],
        [order.direction],
      ),
    [validationRules, order],
  );

  return (
    <TableCDS
      withNoAvailableMessage
      config={validationRulesTableConfig}
      customStyles={tableWrapperStyles}
      data={orderedValidationRules}
      data-testid={UnderwritingTestIds.UW_REPORTS_VALIDATION_RULES_TABLE}
      isCustomDataDefinition={!orderedValidationRules.length}
      isLoading={isLoading}
      order={order}
      skeletonRows={2}
      onRequestSort={onRequestSort}
    />
  );
};

ValidationRulesTable.propTypes = {
  ...WithLoadingPropTypes,
  validationRules: PropTypes.array,
};

export default ValidationRulesTable;
